import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const Counter = ({ value, suffix = "", prefix = "", label, testId }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = performance.now();
    const dur = 1600;
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return (
    <div ref={ref} data-testid={testId}>
      <div className="font-serif font-light text-5xl md:text-6xl tracking-tight text-ink leading-none">
        {prefix}{n}{suffix}
      </div>
      <div className="mt-3 text-[11px] uppercase tracking-[0.2em] text-stone">{label}</div>
    </div>
  );
};
